import React, { createContext, useContext, useEffect, useState } from "react";
import { getAuthToken, setAuthToken, clearAuthToken } from "../lib/auth";
import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../lib/apiClient";
import { profileService } from "../Services/profileService";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [token, setTokenState] = useState(getAuthToken());
  const [user, setUser] = useState(null);

  const { data: profileData, isSuccess } = useQuery({
    queryKey: ["profile"],
    // queryFn: () => apiClient.get(""), // Assuming empty path for profile
    queryFn: () => profileService.useGet(), // Assuming empty path for profile
    enabled: !!token, // Only run if token exists
    staleTime: 10 * 60 * 1000, // 10 minutes
  });

  useEffect(() => {
    if (isSuccess && profileData) {
      setUser(profileData.data);
    }
  }, [profileData, isSuccess]);

  const login = (newToken, userData) => {
    setAuthToken(newToken);
    setTokenState(newToken);
    setUser(userData);
  };

  const logout = () => {
    clearAuthToken();
    setTokenState(null);
    setUser(null);
    // Optional: redirect here or let the ProtectedRoute handle it
    window.location.href = "/account";
  };

  const isAuthenticated = !!token;

  const value = {
    user,
    token,
    isAuthenticated,
    login,
    logout,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  return useContext(AuthContext);
};
